import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

import SolutionSidebar from '../elements/services/solution-sidebar';

import Banner1 from '../../images/banner/banner1.jpg';
import ServicesPic1 from '../../images/services/service_7.jpg';
import ServicesPic2 from '../../images/services/pic2.jpg';

class SolutionFacilityManagement extends Component {

    render() {
        return (
            <>
                <Header1 />

                <div className="page-content bg-white">

                    <div className="page-banner ovbl-dark parallax" style={{ backgroundImage: "url(" + Banner1 + ")" }}>
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">Facility Management & Operations Support</h1>
                                <div className="breadcrumb-row">
                                    <ul className="list-inline">
                                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                                        <li>Facility Management</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-block" id="content-area">

                        <div className="section-area section-sp2">

                            <div className="container about-video">

                                <div className="row">

                                    <div className="col-lg-4 col-md-5 m-b30">
                                         <SolutionSidebar activeService={7} />
                                    </div>

                                    <div className="col-lg-8 col-md-7 service-textarea">

                                        <div className="heading-bx text-left m-b20">
                                            <h3 className="title-head m-b0">Facility Management & Operations Support</h3>
                                            <div className="ttr-separator sepimg"></div>
                                        </div>

                                        <p>
                                            We provide comprehensive facility management and operational support 
                                            for oil & gas, industrial plants, and utilities, ensuring continuity, 
                                            safety, and optimized performance.
                                        </p>

                                        <div className="row m-b30">
                                            <div className="col-md-12">
                                                <img src={ServicesPic1} className="radius-sm imghight" alt="" />
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Our Solutions</h4>
                                        <p>
                                            Our integrated support services ensure smooth facility operations 
                                            through preventive care and qualified field teams.
                                        </p>

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Plant operations support</li>
                                                    <li>Maintenance planning</li>
                                                    <li>Technical assistance</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Safety supervision</li>
                                                    <li>Staff training & HSE services</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Benefits</h4>
                                        <p>
                                            Improved reliability, reduced downtime, and fully compliant operations 
                                            across all facility processes.
                                        </p>

                                        <div className="row">
                                            <div className="col-xl-7 col-lg-12">
                                                <ul className="service-list-circle">
                                                    <li><i className="flaticon-maintenance"></i>Optimized facility performance</li>
                                                    <li><i className="flaticon-light-bolt"></i>24/7 operational support</li>
                                                    <li><i className="flaticon-mask"></i>Improved safety compliance</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                                    <Link to="#">Operations Support</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        Onsite operations teams ensuring continuous plant performance.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                                    <Link to="#">Technical Services</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        Complete technical assistance including inspection, testing, and HSE supervision.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                        </Accordion>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                </div>

                <Footer1 />

            </>
        );
    }
}

export default SolutionFacilityManagement;
